import React, { FC, ReactNode } from 'react';

import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import {
  BIG_MARGIN_PX,
  MIDDLE_MARGIN_PX,
  SKELETON_TEXT_HEIGHT_PX,
  SUBMIDDLE_MARGIN_PX,
  TINY_MARGIN_PX,
} from '~/theme';

interface ILogoutSection {
  children: ReactNode;
  title: string;
  loading?: boolean;
}

const LogoutSection: FC<ILogoutSection> = ({ children, title, loading }) => {
  if (loading) {
    return (
      <GeneratedWrapper>
        <LoadingTitle xs={SKELETON_TEXT_HEIGHT_PX} />
        <div>{children}</div>
      </GeneratedWrapper>
    );
  }

  return (
    <GeneratedWrapper>
      <GeneratedTitle>{title}</GeneratedTitle>
      <div>{children}</div>
    </GeneratedWrapper>
  );
};

export default LogoutSection;

const GeneratedWrapper = styled('div')`
  margin-bottom: ${BIG_MARGIN_PX};

  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin-bottom: 0;

    &:not(:last-child) {
      margin-bottom: ${BIG_MARGIN_PX};
    }
  }
`;
const GeneratedTitle = styled('span')`
  display: block;
  font-size: 20px;
  font-weight: 700;
  border-bottom: 2px solid ${({ theme }) => alpha(theme.palette.common.violet, 0.3)};
  padding: ${TINY_MARGIN_PX} 12px;
  margin-bottom: ${MIDDLE_MARGIN_PX};
`;
const LoadingTitle = styled(AnimatedSkeleton)`
  max-width: 250px;
  margin-bottom: ${SUBMIDDLE_MARGIN_PX};
`;
